import CSV from 'comma-separated-values'
function genCsvUrl (data, options) {
  const encoded = new CSV(data, options).encode()
  const dataBlob = new Blob([`\ufeff${encoded}`], {
    type: 'text/plain;charset=utf-8'
  })
  return window.URL.createObjectURL(dataBlob)
}

function exportData (data, headers, fileName) {
  const url = genCsvUrl(data, headers)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(url)
}

export default {
  exportData
}
